import { useState } from "react";
import { debounce } from "../../../../../utils/debounce";

import { NumericInputBlockProps } from "./NumericInput.type";

const INPUT_COLOR = "#D0D0D0";
const INPUT_COLOR_ERROR = "red";

const NumericInputBlock = ({
  subType,
  label = "",
  fieldName,
  register,
  required,
  min,
  max,
  error,
  setValue,
  readOnly,
  style,
}: NumericInputBlockProps) => {
  const [outOfRangeError, setOutOfRangeError] = useState(false);

  const handleFloat = (n: number) => {
    const numericMin = parseFloat(min);
    const numericMax = parseFloat(max);

    if (n < numericMin || n > numericMax) {
      setOutOfRangeError(true);
      setValue(fieldName, "");
    } else setValue(fieldName, n);
  };

  const handleInteger = (n: number) => {
    const numericMin = parseInt(min, 10);
    const numericMax = parseInt(max, 10);

    if (n < numericMin || n > numericMax) {
      setOutOfRangeError(true);
      setValue(fieldName, "");
    } else setValue(fieldName, n);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;
    if (!value) return setValue(fieldName, "");
    if (subType === "entero") return handleInteger(parseInt(value));
    if (subType === "decimal") return handleFloat(parseFloat(value));
  };

  return (
    <div className="box relative">
      {label ? <span className="">{label}</span> : null}
      <input
        disabled={readOnly}
        className="input"
        type="number"
        fieldName={fieldName}
        register={register}
        required={required}
        min={min}
        max={max}
        error={error}
        onKeyDown={() => outOfRangeError && setOutOfRangeError(false)}
        style={{
          ...style,
          cursor: "pointer",
          borderColor: `${error ? INPUT_COLOR_ERROR : INPUT_COLOR}`,
        }}
        {...register(fieldName, {
          required,
          onChange: debounce(handleChange, 1000),
        })}
      />

      {outOfRangeError && (
        <span style={{ color: INPUT_COLOR_ERROR }}>Valor fuera de rango</span>
      )}

      {error?.message && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
      )}
      {error?.type === "required" && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{label} es requerido*</span>
      )}
    </div>
  );
};

export { NumericInputBlock };
